<div class="row">

    <div class="col-lg-6">

        <div class="position-relative mb-2">
            <img class="search-icon" [src]="constants.staticImages.searchIcon" alt="search icon">
            <input type="text" class="form-control ps-5 pt-1" name="leftSearchString" aria-describedby="leftSearchString" placeholder="Search by category" [(ngModel)]="leftSearchString" (input)="filterLeftSideList()">
        </div>

        <div class="viewport-fit">
            <ng-container *ngFor="let categorywiseList of leftSideEquipmentList">
                <div class="mt-2">
                    <p class="category-text">{{categorywiseList?.category}}</p>
                    <div *ngFor="let eqp of categorywiseList?.equipment" class="d-flex justify-content-between border-bottom mt-2 ms-2">
                        <p class="table-cell">{{eqp.description}} <span title="category">({{eqp?.category}})</span></p>
                        <div class="float-end plus-icon-container me-3">
                            <button class="border-0" title="add" (click)="addToRight(eqp)">
                <img [src]="constants.staticImages.plusIconForm" alt="pluse icon">
              </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

    </div>

    <div class="col-lg-6 side-table mt-1">

        <div class="position-relative mb-2">
            <img class="search-icon" [src]="constants.staticImages.searchIcon" alt="search icon">
            <input type="text" class="form-control ps-5 pt-1" name="rightSearchString" aria-describedby="rightSearchString" placeholder="Search by category" [(ngModel)]="rightSearchString" (input)="filterRightSideList()">
        </div>

        <div class="mx-2 mt-4" *ngIf="rightSideEquipmentList?.length">
            <div class="my-2 border-bottom" *ngFor="let equipment of rightSideEquipmentList">
                <div class="d-flex justify-content-between ">
                    <p class="table-cell">{{equipment?.description}} <span title="category">({{equipment?.category}})</span></p>
                    <div class="float-end plus-icon-container me-3" *ngIf="!isDefaultEquipment(equipment)" (click)="showRemoveEquipmentModal(removeEquipment, equipment)">
                        <button class="border-0" title="add">
              <img [src]="constants.staticImages.crossIcon" alt="cross icon">
            </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row ">
            <div class="col-lg-12 mb-5">
                <div class="float-end">
                    <button class="btn btn-primary" (click)="updateEquipment() ">Update</button>
                    <button class="btn btn-outline-secondary ms-2" (click)="closeModal() ">Cancel</button>
                </div>
            </div>
        </div>

    </div>

</div>

<ng-template #removeEquipment>
    <app-modal title="Remove equipment" [modalRef]="modalRef" [positiveResponse]="confirmRemoveButtonTxt" (onAction)="onConfirmRemove($event) ">
        <p class="modal-body ">Are you sure you want to remove?</p>
    </app-modal>
</ng-template>
